import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.DEBATE_A_BALL;

// Game structure
export const POSSIBLE_RESPONSE_COUNT = 3;
export const CLAIMS_PER_ROUND = 3;
export const CLAIMS_IN_ONBOARDING = 1;
export const ITEMS_PER_CLAIM = 3;
export const QUESTION_COUNT_TO_MASTER_FIRST_LEVEL = 6;
export const QUESTION_COUNT_TO_MASTER_LEVEL = 7;
export const QUESTION_COUNT_TO_UNLOCK_LEVEL = 6;

// These GAME_MODES describe all the possible states of the application for a user at any given time
// Not all of these modes will apply for every game
export const GAME_MODES = {
  // Introduction is an optional "welcome to this game" sequence that explains the conceit and narrative of game
  INTRODUCTION: 'INTRODUCTION',

  // Round play is the main interaction mode of the game when student actually plays
  // ROUND_MODES
  // Feedback occurs after student has responded to a standard question item
  FEEDBACK_POSITIVE: 'FEEDBACK_POSITIVE', // Student just answered a question correctly
  FEEDBACK_NEGATIVE: 'FEEDBACK_NEGATIVE', // Student just answered a question incorrectly
  FEEDBACK_SHOW_CORRECT: 'FEEDBACK_SHOW_CORRECT', // Show student what the correct answer actually was
  // Guidance mode means user is shown some kind of hint on screen (eg, a flashing button that needs to be clicked)
  GUIDANCE: 'GUIDANCE',
  // Onboarding explains how to play the game
  ONBOARDING: 'ONBOARDING',
  ONBOARDING_WAITING_FOR_INPUT: 'ONBOARDING_WAITING_FOR_INPUT',
  ONBOARDING_POSITIVE_FEEDBACK: 'ONBOARDING_POSITIVE_FEEDBACK',
  ONBOARDING_NEGATIVE_FEEDBACK: 'ONBOARDING_NEGATIVE_FEEDBACK',
  // Practice mode normally happens after an incorrect response, so user has a chance to get better at the game's
  // activity on more (typically easier) questions
  PRACTICE: 'PRACTICE',
  // Standard item is a typical question, where student interacts with game to test their
  // skill/knowledge/understanding
  STANDARD_ITEM: 'STANDARD_ITEM',
  // Teaching mode is the pedagogical instruction mode. Often it is Alyx VO explaining a concept to student
  TEACHING: 'TEACHING',

  // View mode means no active round play is underway. Student is just viewing their status/progress in game.
  INACTIVE: 'INACTIVE',
  CLAIM_INTRODUCTION: 'CLAIM_INTRODUCTION',
};

export const isFeedbackMode = gameMode => (
  [GAME_MODES.FEEDBACK_POSITIVE, GAME_MODES.FEEDBACK_NEGATIVE, GAME_MODES.FEEDBACK_SHOW_CORRECT].includes(gameMode)
);

export const CHARACTER_SELECTION_DIMENSIONS = {
  WIDTH: 215,
  HEIGHT: 215,
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  CHARACTER_SELECTION: 'CHARACTER_SELECTION',
  ROUND_INTRODUCTION: 'ROUND_INTRODUCTION',
  VICTORY_SCREEN: 'VICTORY_SCREEN',
};

export const REDUX_ACTIONS = {
  INITIALIZE_GAME: 'INITIALIZE_GAME',
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  LAUNCH_ONBOARDING: 'LAUNCH_ONBOARDING',
  LEVEL_MASTERED: 'LEVEL_MASTERED',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  NEXT_ITEM: 'NEXT_ITEM',
  ROUND_START: 'ROUND_START',
  ROUND_END: 'ROUND_END',
  SHOW_CORRECT_RESPONSE: 'SHOW_CORRECT_RESPONSE',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  SET_ALYX_STATE: 'SET_ALYX_STATE',
  SET_COMPUTER_THINKING: 'SET_COMPUTER_THINKING',
  SET_FIRST_INCORRECT_COMPUTER_ANSWER: 'SET_FIRST_INCORRECT_COMPUTER_ANSWER',
  SET_INCORRECT_ITEMS_FADED: 'SET_INCORRECT_ITEMS_FADED',
  SET_GAME_MODE: 'SET_GAME_MODE',
  SELECT_CHARACTER: 'SELECT_CHARACTER',
  INCREMENT_COMPUTER_POSITIVE_RESPONSES: 'INCREMENT_COMPUTER_POSITIVE_RESPONSES',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_ONLY_RIGHT_ANSWER_HIGHLIGHTED: 'SET_ONLY_RIGHT_ANSWER_HIGHLIGHTED',
  SET_OPTION_STATE: 'SET_OPTION_STATE',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const DISTRACTOR_TYPES = {
  OPINION: 'OPINION',
  NOT_BEST: 'NOT_BEST',
  NOT_ALWAYS: 'NOT_ALWAYS',
};

export const CHARACTER_GROWTH_PARAMS = [
  {
    scale: 1,
    playerX: 53,
    computerX: 865,
    y: 419,
  },
  {
    scale: 1.4,
    playerX: 53,
    computerX: 865,
    y: 399,
  },
  {
    scale: 1.8,
    playerX: 53,
    computerX: 865,
    y: 379,
  },
  {
    scale: 2.2,
    playerX: 53,
    computerX: 865,
    y: 359,
  },
  {
    scale: 2.6,
    playerX: 37,
    computerX: 881,
    y: 339,
  },
  {
    scale: 3,
    playerX: 20,
    computerX: 888,
    y: 319,
  },
  {
    scale: 3.4,
    playerX: 0,
    computerX: 928,
    y: 299,
  },
  {
    scale: 3.8,
    playerX: -8,
    computerX: 936,
    y: 279,
  },
  {
    scale: 4.2,
    playerX: -26,
    computerX: 954,
    y: 259,
  },
  {
    scale: 4.6,
    playerX: -45,
    computerX: 973,
    y: 239,
  },
];
